<template>
  <v-img
      v-if="position !== null"
      :src="require(`@/assets/${getBackgroundImage()}`)"
      height="100%"
      class="ma-0 pa-0"
      cover
  >
    <!-- Dungeon progress - stejný fixní indikátor jako Dungeon.vue, dřív v novém UI chybělo úplně.
         top posunutý pod mobilni v-app-bar (nalez uzivatele 2026-07-23 - "nevidim
         dungeon progress, protoze je za horni listou" - top:0px byl schovany pod
         TopBar.vue mobilnim app-barem, viz .dungeon-progress-badge nize) -->
    <div
        v-if="isDungeonMode"
        style="position: fixed; width: 360px; z-index: 1001; border-radius: 0px 0px 8px 8px"
        class="transparent06--dark dungeon-progress-badge"
    >
      <span style="font-size: 18px;">
        <v-icon color="white">mdi-pokeball</v-icon> {{ $t('journey.battleScreen.dungeonProgressLabel') }}{{ getProgressString() }}
      </span>
    </div>

    <!-- padding-bottom 12px -> 22px -> 17px -> 14px (zadani uzivatele
         2026-08-19, treti kolo - "posun to jeste o 3px") - 14px je presne
         kalibrovane minimum (46px handle team-sheet-peek listy - 32px
         VH_SAFETY_MARGIN_PX, viz .app-screen-bg v _card.sass a main.js) -
         zadna dalsi komfortni rezerva, listu porad nic nezakryva, ale uz to
         nejde zmensit dal beze zmeny samotne kalibrace. -->
    <v-row class="ma-0 pa-0" style="overflow-y: auto; height: 100%; padding-bottom: 14px !important; box-sizing: border-box;">
      <v-col class="ma-0 pa-0" style="height: 100%;">
      <!-- Obstacle mod (zadani uzivatele 2026-07-24, druhe kolo - "dva bloky
           pod sebou, obstacle nahore trener dole") pouziva stejny "stacked"
           grid rezim jako chooseMode (opponent cela sirka nahore, player cela
           sirka pod nim, zadny stred) - neni to "vyber", ale stejny vizualni
           layout presne sedi, viz BattleLayout.vue's battle-layout__row--choose. -->
      <BattleLayout :choose-mode="isChoosingWild || isObstacleMode || isEncounterMode" :dungeon-mode="isDungeonMode">
        <template #player>
          <CombatantSlot
              v-if="isObstacleMode"
              kind="obstacle-trainer"
              :trainer-id="trainer && trainer.id"
              :obstacle-fight="obstacleFight"
          />
          <CombatantSlot
              v-else-if="isFightMode && fight && fight.trainerPokemon"
              kind="pokemon"
              fight
              :pokemon="fight.trainerPokemon"
              :min-height="cardHeight"
              :ditto-skills="fight.trainerDittoSkills"
              :opponent-pokemon="fight.opponentPokemon"
              :hit-report="fight.fightReport2"
              :before-attack-round="fight.beforeAttackRound"
              side="Left"
          />
          <CombatantSlot
              v-else-if="isFightMode"
              kind="choose"
              :min-height="cardHeight"
              :fight-environment="isChoosingWild && fight ? fight.fightEnvironment : null"
              @open-picker="openPicker"
          />
        </template>

        <template #opponent>
          <CombatantSlot
              v-if="isEncounterMode && encounter"
              kind="encounter"
              :encounter="encounter"
              :min-height="cardHeight"
          />
          <CombatantSlot
              v-else-if="isObstacleMode && obstacleFight"
              kind="obstacle"
              :obstacle="obstacleFight.obstacle"
              :obstacle-hp="obstacleFight.currentHp"
              :min-height="cardHeight"
          />
          <CombatantSlot
              v-else-if="isFightMode && fight && fight.opponentPokemon"
              kind="pokemon"
              :pokemon="fight.opponentPokemon"
              :opponent-pokemon="fight.trainerPokemon"
              :unknown="!fight.trainerPokemon"
              :show-details="!fight.active"
              :min-height="cardHeight"
              :hit-report="fight.fightReport2"
              :before-attack-round="fight.beforeAttackRound"
              side="Right"
          />
        </template>

        <template #center>
          <!-- M3 mobilni redesign faze 1, ctvrte kolo (zadani uzivatele
               2026-07-22 - "magnetic field mohl mit porad stejnou grafiku,
               akorat by to bylo prilepeno na choose pokemon"): behem
               isChoosingWild se stred vubec nerenderuje (BattleLayout
               chooseMode=true ho skryje cele) - environment pilulka je
               misto toho "prilepena" primo na Choose pokemon ctverecek,
               viz :fight-environment prop vyse a CombatantSlot.vue.

               Obstacle mod (zadani uzivatele 2026-07-24, druhe kolo - "počet
               kol tam vůbec nemá co dělat") uz stred vubec nepouziva - taky
               je v chooseMode (viz vyse), takze BattleLayout ho stejnym
               mechanismem cele skryje, zadny obstacle vetev tu neni. -->
          <BattleCenter
              v-if="isFightMode && fight"
              mode="fight"
              :fight="fight"
              :trainer="trainer"
              :position="position"
              :is-trainer-fight="isTrainerFight"
          />
        </template>

        <!-- #trainers slot docasne nepouzity (zadani uzivatele 2026-07-23 -
             "trenery tam zatim nikde nezobrazuj") - stary nepresylovany
             blok za fixni akcni listou pridaval extra vysku bez vlastniho
             spaceru, cimz zpusoboval "view o listu delsi nez by melo byt"
             scroll bug; pozdeji (2026-07-24) se ukazalo, ze i prazdny
             <template #trainers> s jen komentarem uvnitr necha BattleLayout.vue's
             $slots['trainers'] pravdivy a vykresli prazdny wrapper div navic
             (viz BattleLayout.vue) - proto se cely blok radeji vynechava
             uplne, ne jen komentuje obsah. Znovu se zapoji az s trenerskymi
             ctverecky, viz M3 faze 2 v claude/battle-screen-design.md. -->

        <template
            v-if="!pendingTrainerWin && ((isFightMode && fight && fight.trainerPokemon) || (isObstacleMode && obstacleFight))"
            #skill-actions
        >
          <!-- Vyber+pouziti skillu - vytazeno z FightReport.vue do vlastni
               komponenty (zadani uzivatele 2026-07-23 - "vyber skillu a
               pouziti schopnosti bych odtedka rad mel ve vlastni komponente
               a designoval ji stejne jako actionbar, akorat nad action bar,
               do dvou radku"). Stav (selectedSkill) je ted tady, ne ve
               FightReport - ta uz jen zobrazuje report, vyber/pouziti resi
               tenhle blok, umisteni (fixed nad action barem) resi
               BattleLayout.vue.

               Obstacle mod (zadani uzivatele 2026-07-24, obstacle parita s
               fightem, claude/battle-screen-design.md faze 5) sdili stejnou
               komponentu - obstacle skilly maji stejny tvar dat jako
               pokemon skilly (name/type/minDmg/maxDmg/defence), jen jiny
               "pool" (position.obstacleSkills misto pokemonich skillu, viz
               getObstacleSkills() - zadny koncept "uz pouzito v tomhle
               kole", proto vsechny disabled:false).

               OPRAVA (2026-08-07, nalez uzivatele - "skáčou a scvakávají se
               pořád okýnka, když skončí fight, tak se nezmizí ten use skill
               panel"): drive tahle lista po porazeni prekazky (passedObstacle)
               ZMIZELA CELA (`&& !passedObstacle` v podmince #skill-actions
               slotu vyse) - vizualne to trhalo obrazovku pri prechodu z
               "posledni zasah" na "prekazka porazena". Ted lista zustava
               viditelna dal, jen `:can-fight` (nize) spravne zakaze dalsi
               pouziti skillu (neni uz co vybirat, ale okno se nezavira samo).

               DULEZITY rozdil oproti fightu (nalezeno zive Playwrightem
               2026-07-24): obstacle NEMA zadny "base move"/"base attack"
               ekvivalent - ObstacleService::fightObstacle() vyzaduje vzdy
               realny skillId (backend na null tvrde spadne, 500). Puvodni
               ObstacleSkillPicker.vue proto mel "Use skill" natvrdo
               disabled, dokud neco nevyberes, a zadne druhe tlacitko vubec
               nemel - "Base attack 1-6" byl jen placeholder textu prazdneho
               v-select, nikdy skutecne odeslatelna akce. allow-base-move
               a require-selection nize replikuji presne tohle chovani. -->
          <SkillActionBar
              :skills="isObstacleMode ? getObstacleSkills() : getSkills()"
              :selected-skill-id="selectedSkill"
              :can-fight="isObstacleMode ? !passedObstacle : readyToFight()"
              :base-label="isObstacleMode ? $t('journey.battleScreen.selectSkillLabel') : $t('journey.battleScreen.baseMoveLabel')"
              :allow-base-move="!isObstacleMode"
              :require-selection="isObstacleMode"
              :round-role="roundRole"
              :next-round-hint="nextRoundHint"
              @open-picker="showSkillPicker = true"
              @clear-skill="selectedSkill = null"
              @use-skill="useSelectedSkill"
              @use-base-move="useBaseMove"
          />
        </template>

        <template #actions>
          <BattleActions
              :mode="actionsMode"
              :position="position"
              :trainer="trainer"
              :fight="fight"
              :obstacle-fight="obstacleFight"
              :is-trainer-fight="isTrainerFight"
              :is-dungeon-challenge="isDungeonChallenge"
              :go-to-dungeon="goToDungeon"
              :reset-skill="resetSkill"
              @recall-pokemon="openPicker"
              @choose-pokemon="openPicker"
          />
        </template>
      </BattleLayout>

      <PokemonPickerDialog
          v-model="showPicker"
          :pokemons="pokemonsToChooseFiltered"
          :allow-fainted="isTeamRocketAmbush"
          :dungeon-available-skill-ids="isDungeonMode ? position.trainerPokemonSkills : null"
          @choose="chooseToFight"
      />
      <SkillPickerDialog
          v-model="showSkillPicker"
          :skills="isObstacleMode ? getObstacleSkills() : getSkills()"
          :round-role="roundRole"
          @choose="(skill) => { selectedSkill = skill.id; }"
      />
      <ConfirmDialog ref="confirmDialog"/>
      </v-col>
    </v-row>
  </v-img>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {Positions} from '@/utils/positionEnum';
import {API_ENTRYPOINT} from "@/config/entrypoint";
import BattleLayout from '@/components/journey/positions/battle/BattleLayout';
import CombatantSlot from '@/components/journey/positions/battle/CombatantSlot';
import BattleCenter from '@/components/journey/positions/battle/BattleCenter';
import BattleActions from '@/components/journey/positions/battle/BattleActions';
import PokemonPickerDialog from '@/components/journey/positions/battle/PokemonPickerDialog';
import SkillPickerDialog from '@/components/journey/positions/battle/SkillPickerDialog';
import SkillActionBar from '@/components/journey/positions/battle/SkillActionBar';
import ConfirmDialog from '@/components/utils/ConfirmDialog';
import {isHpGateSatisfied} from '@/utils/skillDisplay';

// Sjednocená bojová obrazovka (flags.newBattleUi je od M0.1, 2026-08-04, natvrdo
// zamčený na true v LOCKED_ON) - nahradila trojici Fight2.vue / Dungeon.vue /
// ObstacleFight.vue, ty jsou po dokončení migrace smazané.
// Funkční parita: BattleCenter/BattleActions viz claude/battle-screen-design.md,
// pořadí stavby - grid+sloty hotové, střed a akce napojené na existující logiku.
//
// M3 mobilní redesign, fáze 1 (zadání uživatele 2026-07-22, viz
// battle-screen-design.md sekce "M3 mobilní redesign"): "choose" stav
// (CombatantSlot kind="choose") už neukazuje inline PokemonToChoose pod
// gridem, ale otevírá sdílený PokemonPickerDialog (stejná komponenta i pro
// Recall - fight.trainerPokemon se po recallu vynuluje a UI se samo vrátí
// do "choose" stavu, žádné zvláštní zapojení navíc).
export default {
  name: "BattleScreen",
  components: {BattleLayout, CombatantSlot, BattleCenter, BattleActions, PokemonPickerDialog, SkillPickerDialog, SkillActionBar, ConfirmDialog},
  props: {
    position: {type: Object, default: null},
    trainer: {type: Object, default: null},
    fight: {type: Object, default: null},
    obstacleFight: {type: Object, default: null},
    encounter: {type: Object, default: null},
  },
  data() {
    return {
      positions: Positions,
      pokemonsToChoose: [],
      showPicker: false,
      // Vyber skillu (presunuto z FightReport.vue, viz SkillActionBar.vue) -
      // jediny zdroj pravdy pro aktualne vybrany skill v boji.
      selectedSkill: null,
      showSkillPicker: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/item',
      pendingTrainerWin: 'journey/pendingTrainerWin',
    }),
    // vyloucen aktualne bojujici pokemon z nabidky (zadani uzivatele - "pokud
    // recalluju, tak nezobrazuj toho, ktery je zrovna in battle") - v praxi se
    // tyka jen okamziku mezi recall requestem a odpovedi, kdy uz fight.active
    // muze byt false, ale stara reference trainerPokemon jeste nedorazila
    pokemonsToChooseFiltered() {
      const activeId = this.fight && this.fight.trainerPokemon ? this.fight.trainerPokemon.id : null;
      return this.pokemonsToChoose.filter((p) => p.id !== activeId);
    },
    isDungeonMode() {
      return this.position.type === this.positions.DUNGEON ||
          this.position.type === this.positions.DUNGEON_CHALLENGE;
    },
    isFightMode() {
      const fightTypes = [
        this.positions.FIGHT, this.positions.FIGHT_TRAINER, this.positions.LEAGUE_FIGHT,
        this.positions.MEWTWO_FIGHT, this.positions.FIGHT_TEAM_ROCKET,
      ];
      if (fightTypes.includes(this.position.type)) return true;
      if (this.isDungeonMode && this.position.wild && this.position.wild.dungeon.actualPosition === 'pokemon') {
        return true;
      }
      return false;
    },
    isObstacleMode() {
      if (this.position.type === this.positions.WILD_OBSTACLE) return true;
      if (this.isDungeonMode && this.position.wild && this.position.wild.dungeon.actualPosition === 'obstacle') {
        return true;
      }
      return false;
    },
    isEncounterMode() {
      return this.position.type === this.positions.ENCOUNTER;
    },
    // 'attack'/'defence'/null - zadani uzivatele 2026-08-17 ("misto Use skill
    // mit na tlacitku Attack skill/Defence skill podle kola"). Obstacle nema
    // tuhle dualitu (vzdy jen "Select skill", viz SkillActionBar.vue base-label
    // vyse) - null tam zachova puvodni generic label.
    roundRole() {
      if (this.isObstacleMode || !this.fight) return null;
      return this.fight.attackRound ? 'attack' : 'defence';
    },
    // Presunuto z FightReportDuel.vue's drivejsi nextRoundSub (zadani
    // uzivatele 2026-08-17 - "next round musi byt prelepene dole u skill
    // pickeru") - stejna logika (stunned pokemon vynechava priste svoje
    // kolo), jen ted pocitana tady, protoze banner uz zobrazuje
    // SkillActionBar, ne FightReport.
    nextRoundHint() {
      if (this.isObstacleMode || !this.fight || !this.fight.fightReport2 || !this.fight.fightReport2.stunned) {
        return null;
      }
      const skippedPokemon = this.fight.attackRound ? this.fight.opponentPokemon : this.fight.trainerPokemon;
      const skippedName = skippedPokemon ? skippedPokemon.name : '';
      // fight.attackRound=true => skipped pokemon je opponent, tzn. NEPRITEL
      // je stunnuty a hrac utoci znovu - z hracovy perspektivy je to vyzva k
      // akci ("attack again"), ne jen neutralni fakt ("turn skipped"), viz
      // zadani uzivatele 2026-08-17. Opacny pripad (hracuv vlastni pokemon
      // stunnuty, souper utoci znovu) zustava "turn skipped" - pro hrace
      // neni co delat.
      return this.fight.attackRound
          ? skippedName + this.$t('journey.battleScreen.stunnedAttackAgainSuffix')
          : skippedName + this.$t('journey.battleScreen.stunnedTurnSkippedSuffix');
    },
    // Presne stejna podminka jako "attack again!" vetev nextRoundHint vyse -
    // souper je prave stunnuty a hrac utoci znovu (zadani uzivatele
    // 2026-08-21 - "pokud je nepritel omracenej, tak by do razeni mohlo byt
    // do dmg pripocitan bonus za lunge... at predrazuje pred jinymy jinak
    // stejne silnymi skilly"). Backend (FightService::fightPokemons2) pridava
    // LUNGE effectBonus presne v tomhle pripade (attSkill && $stunnedBefore),
    // sortByBestDmg() nize pouziva stejnou podminku jen pro RAZENI (zobrazeny
    // dmg rozsah zustava nezmeneny, meni se jen poradi v listu).
    opponentStunnedForLunge() {
      return !!(this.fight && this.fight.attackRound && this.fight.fightReport2 && this.fight.fightReport2.stunned);
    },
    isTrainerFight() {
      return this.position.type === this.positions.FIGHT_TRAINER ||
          this.position.type === this.positions.FIGHT_TEAM_ROCKET ||
          this.position.type === this.positions.LEAGUE_FIGHT ||
          this.position.type === this.positions.MEWTWO_FIGHT;
    },
    isDungeonChallenge() {
      return this.position.type === this.positions.DUNGEON_CHALLENGE;
    },
    // Zadani uzivatele 2026-08-12 - jen v tomhle pripade smi picker nabidnout
    // i 0 HP pokemony (viz PokemonPickerCard.vue allowFainted prop) k
    // "vzdani se" raketakum, kdyz hrac nema zadneho ziveho pokemona k
    // vyberu (jinak by byl bez moznosti pokracovat - RUN! i normalni Choose
    // vyzaduji ziveho pokemona).
    isTeamRocketAmbush() {
      return this.position.type === this.positions.FIGHT_TEAM_ROCKET;
    },
    // "choose/encounter" stav, jen divoky souboj (ne trenersky) - M3
    // mobilni redesign faze 1, treti kolo (viz komentar u #center vyse)
    isChoosingWild() {
      return this.isFightMode && !!this.fight && !this.fight.trainerPokemon && !this.isTrainerFight;
    },
    // Vyska pokemon karet (zadani uzivatele 2026-07-23 - "na 800px vysku by
    // se melo vejit pokemon karta i fight report na jednu page, bez
    // scrollovani, rozdeleni 50/50", pozdeji rozsireno i na chooseMode -
    // "obe karty jak pokemon tak pokebal meli delit plochu 50/50") - karta
    // se vzdy roztahne na celou vysku sve grid bunky ("100%"); na mobilu
    // je ta bunka dana 50/50 splitem v BattleLayout.vue (aktivni souboj i
    // chooseMode), na desktopu ma PokemonDetail.vue/CombatantSlot.vue
    // vlastni !important override zpet na 400px (tam grid bunka neni
    // vyskove definovana, viz komentare tam).
    cardHeight() {
      return '100%';
    },
    passedObstacle() {
      return this.obstacleFight !== null && this.obstacleFight.currentHp < 1;
    },
    actionsMode() {
      if (this.isDungeonMode) return 'dungeon';
      if (this.isObstacleMode) return 'wild-obstacle';
      if (this.isEncounterMode) return 'encounter';
      return 'fight';
    },
  },
  watch: {
    fight() {
      if (this.isFightMode && this.fight && !this.fight.trainerPokemon) {
        this.loadPokemonsToChoose();
      }
      // Nove kolo/novy pokemon -> znovu vybrat prvni pouzitelny skill
      // (presunuto z FightReport.vue, drivejsi watch: {fight(){...}}).
      this.getFirstSkill();
    },
    // Presunuto z ObstacleSkillPicker.vue (drivejsi watch: {obstacleFight(){
    // this.selectedSkill = null }}) - ted sdili stejnou selectedSkill promennou
    // jako fight (viz getObstacleSkills()/useSelectedSkill() nize), takze reset
    // po kazdem kole musi resit BattleScreen, ne uz smazana obstacle karta.
    //
    // DULEZITE (nalezeno zive 2026-07-24, viz "skill picker uz nenabizi
    // nejlepsi skill jako prvni"): KAZDA Position ma defaultne prazdny
    // ObstacleFight (Position::__construct() - "$this->setObstacleFight(new
    // ObstacleFight())"), a je v "position" serializacni skupine, ktera je
    // soucasti getRightGroups() i pro obycejny FIGHT. Kazdy fresh JSON
    // (kazde kolo pokemon souboje, ne jen obstacle) tak vytvori NOVY
    // obstacleFight OBJEKT (jina reference, i kdyz stejny obsah), takze
    // tenhle watcher bez isObstacleMode guardu vypaloval PO KAZDEM kole
    // pokemon souboje taky - mazal prave nastaveny nejlepsi skill hned po
    // getFirstSkill() vyse. Guard: resetovat jen kdyz na obstacleFight
    // skutecne zalezi (obstacle mod).
    //
    // Reset uz neznamena proste null - zadani uzivatele 2026-07-24 "picker
    // by mel napovidat vzdy nejsilnejsi utok i u obstacles" - stejne jako
    // getFirstSkill() u pokemon souboje, viz getFirstObstacleSkill() nize.
    obstacleFight() {
      if (this.isObstacleMode) {
        this.getFirstObstacleSkill();
      }
    },
  },
  created() {
    if (this.isFightMode && this.fight && !this.fight.trainerPokemon) {
      this.loadPokemonsToChoose();
    }
    this.trainerInfoMessages(this.user.id);
    this.getFirstSkill();
    if (this.isObstacleMode) {
      this.getFirstObstacleSkill();
    }
  },
  methods: {
    ...mapActions({
      positionPost: 'journey/positionPost',
      fetchObj: 'journey/fetchObject',
      pokemonFight: 'journey/pokemonFight',
      trainerInfoMessages: 'trainer/loadInfoMessages',
    }),
    loadPokemonsToChoose() {
      let url = new URL("api/pokemon-preselect", API_ENTRYPOINT);
      url.searchParams.set('trainer', this.trainer.id);
      url.searchParams.set('inProfesorOak', false);
      url.searchParams.set('stolen', false);
      url.searchParams.set('order[edited]', 'asc');
      const obj = {url: url, method: 'GET'};
      this.fetchObj(obj).then(
          (data) => {
            this.pokemonsToChoose = data['member'];
          }
      );
    },
    // Znovunacte poradi tesne pred otevrenim pickeru (zadani uzivatele
    // 2026-08-14 - "pokud zmenim poradi pokemonu, melo by se to hned
    // projevit taky v pickeru") - drive se `pokemonsToChoose` nacitalo jen
    // v created()/fight watcheru, takze preskladani tymu (TeamBottomSheet,
    // `order[edited]` perzistovane primo na serveru) se do uz otevreneho
    // pickeru nemuselo dostat, hlavne pres tlacitko "Recall" (kde `fight`
    // watcher kvuli stale nastavenemu trainerPokemon vubec nevypali).
    openPicker() {
      this.loadPokemonsToChoose();
      this.showPicker = true;
    },
    chooseToFight(pokemon) {
      // Zadani uzivatele 2026-08-12 - klik na 0 HP kartu je mozny jen kdyz
      // je picker v "allowFainted" rezimu (viz PokemonPickerDialog.vue) -
      // tam uz to neni volba pokemona do souboje, ale jeho vzdani se
      // raketakum (viz donateToTeamRocket nize).
      if (pokemon.hp < 1) {
        this.donateToTeamRocket(pokemon);
        return;
      }
      const url = new URL("api/add-to-fight", API_ENTRYPOINT);
      const obj = {url: url, obj: {pokemonId: pokemon.id, pokemonFightId: this.fight.id}, method: 'POST'}
      this.positionPost(obj);
    },
    async donateToTeamRocket(pokemon) {
      const rlyDonate = await this.$refs.confirmDialog.open(
          this.$t('journey.battleScreen.confirmDonateToTeamRocket', {name: pokemon.name || pokemon.pokemonType.name})
      );
      if (!rlyDonate) {
        return;
      }
      const url = new URL("api/donate-pokemon-team-rocket", API_ENTRYPOINT);
      const obj = {url: url, obj: {pokemonId: pokemon.id, positionId: this.position.id}, method: 'POST'}
      this.positionPost(obj);
    },
    callPokemonFight(id) {
      const obj = {
        pokemonFightId: this.fight.id,
        skillId: id,
      };
      this.pokemonFight(obj).then(
          () => {
            this.trainerInfoMessages(this.user.id);
          }
      );
    },
    fightObstacle(skillId) {
      const url = new URL("api/fight-wild-obstacle", API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id, skillId: skillId}, method: 'POST'}
      this.positionPost(obj);
    },
    goToDungeon() {
      let strUrl = "api/go-dungeon";
      if (this.isDungeonChallenge) {
        strUrl = "api/go-dungeon-challenge";
      }
      const url = new URL(strUrl, API_ENTRYPOINT);
      const obj = {url: url, obj: {positionId: this.user.position.id, stepCost: 0}, method: 'POST'}
      // Na rozdíl od callPokemonFight() tohle dřív nevolalo trainerInfoMessages
      // po dokončení - BattleScreen zůstává přes celý průchod dungeonem
      // pořád stejná mountnutá instance (created() vystřelí jen jednou při
      // vstupu), takže toast na pokeball/masterball nalezený mid-dungeonu se
      // nezobrazil hned, jen se nahromadil a vyplaval až na obrazovce, co si
      // zprávy natáhne sama (DungeonWinNext/CityNext).
      this.positionPost(obj).then(() => {
        this.trainerInfoMessages(this.user.id);
      });
    },
    resetSkill() {
      // no-op: DungeonButtons.vue volá canContinueRoad() (a tedy tuhle
      // funkci) na každý render, ne jen při skutečném přechodu - kdyby
      // mazala selectedSkill, smaže i právě vybraný pokémon skill uprostřed
      // běžného kola. Reset po skončení obstacle kola řeší watch: obstacleFight()
      // výše, ne tenhle prop.
    },
    getProgressString() {
      if (this.isDungeonChallenge) {
        return ": " + this.position.wild.dungeon.currentStep;
      }
      return " " + this.position.wild.dungeon.currentStep + " / " + this.position.wild.dungeon.steps;
    },
    isDisabled(skill) {
      let isAvalaible = this.fight.trainerPokemonSkills.find(function (x) {return skill.id == x });
      return !isAvalaible;
    },
    // Nejlepsi (nejvyssi rateDmg) skill vzdy prvni - sdileny komparator pro
    // vsechny skill-listy (fight/dungeon/obstacle), drive kopirovany zvlast
    // v kazdem miste a v getDungeonFightSkills()/getObstacleSkills() chybel
    // uplne (zadani uzivatele 2026-07-24 - "skill picker uz nenabizi nejlepsi
    // skill jako prvni, a to je zasadni chyba").
    //
    // lungeBonusActive (zadani uzivatele 2026-08-21) - kdyz je souper prave
    // stunnuty (viz opponentStunnedForLunge), LUNGE skilly realne udeli
    // effectBonus navic (FightService.php), takze se stejny bonus pripocita
    // i sem do RAZENI, at se takovy skill predsune pred jinak stejne silne
    // skilly bez lunge. Jen razeni - zobrazeny minDmg/maxDmg zustava beze
    // zmeny, ten pocita backend uz bez ohledu na aktualni stun stav.
    sortByBestDmg(skills, lungeBonusActive = false) {
      const effectiveDmg = (s) => s.rateDmg + (lungeBonusActive && s.effect === 'LUNGE' ? s.effectBonus : 0);
      return skills.slice().sort((a, b) => effectiveDmg(b) - effectiveDmg(a));
    },
    // Nejlepsi skill pro auto-vyber, ktery respektuje HP-gated efekty (zadani
    // uzivatele 2026-08-28 - "protoze moje nejsilnejsi skill je heal, tak se
    // predvybere v picker, ale dokud nemam pod prah zivotu, tak by se mel z
    // predvyberu ignorovat"). sortedSkills uz je serazeny nejlepsi-prvni
    // (sortByBestDmg) - vezme prvni polozku, ktere HP-prah (viz
    // isHpGateSatisfied) nebrani, a jen kdyz uplne vsechny pouzitelne skilly
    // jsou gated a nesplnene (hrac nema jinou volbu), spadne zpet na
    // absolutne nejlepsi.
    pickBestUsableSkill(sortedSkills, hp, maxHp) {
      if (sortedSkills.length === 0) {
        return null;
      }
      const eligible = sortedSkills.find((s) => isHpGateSatisfied(s.effect, hp, maxHp));
      return eligible || sortedSkills[0];
    },
    // Presunuto z FightReport.vue (zadani uzivatele 2026-07-23 - viz
    // SkillActionBar.vue) - jediny zdroj pravdy pro vyber/pouziti skillu.
    readyToFight() {
      if (this.fight && this.fight.trainerPokemon) {
        if (this.fight.trainerPokemon.hp >= 1 && this.fight.opponentPokemon.hp >= 1) {
          return true;
        }
      }
      return false;
    },
    getFirstSkill() {
      this.selectedSkill = null;
      if (!this.fight || !this.fight.trainerPokemon) {
        return;
      }
      const hp = this.fight.trainerPokemon.hp;
      const maxHp = this.fight.trainerPokemon.maxHp;
      if (this.isDungeonMode) {
        let newSkills = this.getSkills();
        if (newSkills.length > 0) {
          newSkills = this.sortByBestDmg(newSkills, this.opponentStunnedForLunge);
          const best = this.pickBestUsableSkill(newSkills, hp, maxHp);
          this.selectedSkill = best ? best.id : null;
        }
      } else {
        let attRound = this.fight.attackRound;
        let skillSource = this.fight.trainerPokemon.skills;
        if (this.fight.trainerPokemon.isDitto) {
          skillSource = this.fight.trainerDittoSkills;
        }
        let skills = skillSource.filter((f) => {return !!f.defence === !attRound });
        for (let key in skills) {
          let skill = skills[key];
          skill.disabled = this.isDisabled(skill);
          skills[key] = skill;
        }
        let unused = this.sortByBestDmg(skillSource.filter((f) => {return f.disabled === false }), this.opponentStunnedForLunge);
        const best = this.pickBestUsableSkill(unused, hp, maxHp);
        if (best) {
          this.selectedSkill = best.id;
        }
      }
    },
    useSelectedSkill() {
      if (this.isObstacleMode) {
        this.fightObstacle(this.selectedSkill);
        this.selectedSkill = null;
        return;
      }
      this.callPokemonFight(this.selectedSkill);
      this.getFirstSkill();
    },
    useBaseMove() {
      // Jen fight mod - obstacle nema "base move" ekvivalent, SkillActionBar
      // dostava allow-base-move="false" pro obstacle (viz sablona vyse), takze
      // se tenhle handler v obstacle modu vubec nevyvola.
      this.callPokemonFight(null);
      this.getFirstSkill();
    },
    // Obstacle skilly maji stejny tvar dat jako pokemon skilly (viz stary
    // v-select v ObstacleSkillPicker.vue), ale zadny koncept "uz pouzito v
    // tomhle kole" - SkillActionBar's hasUsableSkills pocita s disabled===false,
    // takze se to explicitne nastavi na kazdem (zadani uzivatele 2026-07-24).
    //
    // effectiveObstacleSkills (ne stary obstacleSkills!) - zadani uzivatele
    // 2026-07-24, "filtrovani efektivnich utoku na znama obstacles"
    // (roadmap.md bod 6). Backend (Position::getEffectiveObstacleSkills())
    // vraci profiltrovany pool JEN kdyz hrac danou prekazku "zna" (ma
    // odznak stadionoveho trenera, ktery ji prozradil), jinak vraci stejna
    // data jako puvodni obstacleSkills (necha hrace hadat). Puvodni
    // obstacleSkills pole na FE po smazani Dungeon.vue/ObstacleFight.vue (M0.1,
    // 2026-08-04) uz nikde nepouzivame, backend ho ale porad posila - zustava
    // otevrene v ramci revize obstacle-encounter mechaniky (roadmap.md bod 6).
    getObstacleSkills() {
      if (!this.position || !this.position.effectiveObstacleSkills) {
        return [];
      }
      return this.sortByBestDmg(this.position.effectiveObstacleSkills.map((s) => ({...s, disabled: false})));
    },
    // Analogie getFirstSkill() pro obstacle mod (zadani uzivatele 2026-07-24
    // - "picker by mel napovidat vzdy nejsilnejsi utok i u obstacles") -
    // getObstacleSkills() uz je serazeny nejlepsi-prvni (sortByBestDmg),
    // takze staci vybrat prvni polozku. Samostatna metoda, ne vetev v
    // getFirstSkill() - ta je celá postavena kolem this.fight.trainerPokemon,
    // ktery v obstacle modu vubec neexistuje.
    getFirstObstacleSkill() {
      const skills = this.getObstacleSkills();
      this.selectedSkill = skills.length > 0 ? skills[0].id : null;
    },
    getFightSkills() {
      let attRound = this.fight.attackRound;
      let skillSource = [];
      if (this.fight.trainerPokemon) {
        skillSource = this.fight.trainerPokemon.skills;
      }
      if (this.fight.trainerPokemon && this.fight.trainerPokemon.isDitto) {
        skillSource = this.fight.trainerDittoSkills;
      }
      if (this.fight && this.fight.trainerPokemon) {
        let skills = skillSource.filter((f) => {return !!f.defence === !attRound });
        for (let key in skills) {
          let skill = skills[key];
          skill.disabled = this.isDisabled(skill);
          skills[key] = skill;
        }
        let unused = this.sortByBestDmg(skillSource.filter((f) => {return f.disabled === false }), this.opponentStunnedForLunge);
        let used = skillSource.filter((f) => {return f.disabled === true });
        used.sort(function (a, b) {
          var nameA = a.formula.toUpperCase();
          var nameB = b.formula.toUpperCase();
          if (nameA < nameB) return 1;
          if (nameA > nameB) return -1;
          return 0;
        });
        return unused.concat(used);
      }
      return [];
    },
    getDungeonFightSkills() {
      let attRound = this.fight.attackRound;
      let result = [];
      if (this.fight.trainerPokemon) {
        let skills = this.fight.trainerPokemon.skills.filter((f) => {return !!f.defence === !attRound });
        const idIsInList = id => this.position.trainerPokemonSkills.includes(id);
        // disabled explicitne false - vsechno, co projde idIsInList filtrem, je
        // "aktualne dostupne" (na rozdil od fight vetve dungeon nema samostatny
        // "uz pouzito" seznam napojeny za nim), SkillActionBar's hasUsableSkills
        // vyzaduje disabled===false, ne jen undefined (zadani uzivatele
        // 2026-07-24 - "skill picker uz nenabizi nejlepsi skill jako prvni").
        result = skills.filter(item => idIsInList(item.id.toString())).map((s) => ({...s, disabled: false}));
      }
      return this.sortByBestDmg(result, this.opponentStunnedForLunge);
    },
    getSkills() {
      // Nalez uzivatele 2026-07-23 (Vue render error, "can't access property
      // attackRound, this.fight is null") - <SkillPickerDialog :skills="getSkills()">
      // se (na rozdil od puvodniho BattleCenter, ktery byl cely za v-if="fight")
      // renderuje VZDY, i kdyz fight je null (napr. hned po vyhranem fightu,
      // nez se stranka prekresli na jiny position.type) - getFightSkills()/
      // getDungeonFightSkills() sahaly na this.fight.attackRound bez kontroly.
      if (!this.fight) {
        return [];
      }
      return this.isDungeonMode ? this.getDungeonFightSkills() : this.getFightSkills();
    },
    getBackgroundImage() {
      const prefix = "pic/position/";
      if (this.position.type === this.positions.FIGHT_TEAM_ROCKET) return prefix + 'TEAM_ROCKET.png';
      if (this.isDungeonMode) return prefix + 'DUNGEON.png';
      // Encounter pouziva obrazek konkretniho NPC/EncounterType jako
      // skutecne celoobrazovkove pozadi (viz docs/superpowers/specs/
      // 2026-09-07-encounter-fullscreen-fe-design.md) - encounterType.img
      // uz nese tvar '/encounter/xxx.jpg' (stejny format jako drive
      // pouzival EncounterCard.vue's require).
      if (this.isEncounterMode && this.position.encounter && this.position.encounter.encounterType
          && this.position.encounter.encounterType.img) {
        return 'pic' + this.position.encounter.encounterType.img;
      }
      if (this.position.type === this.positions.LEAGUE_FIGHT) return prefix + 'LEAGUE_FIGHT.png';
      if (this.position.type === this.positions.MEWTWO_FIGHT) return prefix + 'MEWTWO_FIGHT.png';
      // Stadionový souboj má vlastní pozadí konkrétního gymu (mimo složku position/)
      if (this.isTrainerFight && this.position.trainerFight && this.position.trainerFight.stadionFight
          && this.position.city && this.position.city.stadion) {
        return "pic/stadion/gyms/" + this.position.city.stadion.badge.id + '.png';
      }
      if (this.isTrainerFight && this.position.trainerFight && !this.position.trainerFight.stadionFight) {
        return prefix + 'TRAINER_FIGHT_WILD.png';
      }
      if (this.position.wild && this.position.actualWildType) {
        return prefix + 'FIGHT_BIOMS/WILD_' + this.position.actualWildType + '.png';
      }
      if (this.isObstacleMode) return prefix + 'OBSTACLE_FIGHT.png';
      if (this.isFightMode) return prefix + 'FIGHT.png';
      return prefix + this.position.type + '.png';
    },
  },
}
</script>

<style scoped>
.dungeon-progress-badge {
  /* desktop: puvodni hodnota z Dungeon.vue - pocita s 260px sidebarem
     (zustava, ma-li se zachovat parita se starym UI na desktopu) */
  top: 0px;
  left: 260px;
  /* Vyslovna vyska (misto puvodniho ma-2/pa-2 na vnitrnim inline <span>,
     ktere vizualne vypadalo jako padding, ale na vysku boxu se
     NEPROJEVOVALO - vertikalni padding/margin na inline prvku nerozsiruje
     radkovy box, viz CSS spec) - deterministicka vyska, na kterou se pak
     presne (ne odhadem) navazuje BattleLayout.vue's .battle-layout__row--dungeon
     padding-top, aby karty navazovaly bez mezery (zadani uzivatele
     2026-07-23 - "by na sebe meli navazovat, je tam nesmyslne velka mezera" -
     puvodni odhad 80px byl 2x vetsi nez skutecna vyska badge). */
  height: 36px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}
@media (max-width: 959px) {
  .dungeon-progress-badge {
    /* mobil: TopBar.vue ma presne 60px vysoky v-app-bar (viz TopBar.vue,
       v-app-bar height="60") - top:60px ho "prilepi" primo pod listu bez
       mezery (zadani uzivatele 2026-07-23 - "prilep na listu horni"),
       predtim top:64px delal 4px viditelnou mezeru.
       left: na mobilu zadny 260px sidebar neni (nalez uzivatele - "dungeon
       dej doleva ne doprava" - stary left:260px ho na uzkych mobilech
       posouval mimo/na kraj obrazovky), takze doleva k okraji. */
    top: 60px;
    left: 0px;
  }
}

/* Nalez uzivatele 2026-07-23/24 - "action bar posunuty dolu a neni videt"
   (potvrzeno screenshoty). Puvodni <v-img height="100vh"> byla VZDY presne
   cela vyska obrazovky, i kdyz ji v-main na mobilu posouva o vysku TopBaru
   dolu (padding-top, viz ".new-shell-ui .v-main" v App.vue) - box tak
   zacinal niz, ale byl porad stejne vysoky, takze spodni cast (prave akcni
   lista) prepadavala mimo viditelnou oblast. Prvni pokus o opravu
   (calc(100vh - 60px) na v-img i v-row, natvrdo odectena vyska TopBaru) byl
   zbytecny a krehky dvojity odhad - "new-shell-ui .v-main" uz sam o sobe
   resi presne tohle (height:100vh + padding-top, box-sizing:border-box, viz
   App.vue radky ~536-544 - stejny mechanismus, jaky uz spolehlive pouzivaji
   ostatni stranky, napr. TrainerDetail/Pokedex/Dashboard). Overil jsem si i
   ve zdrojacich Vuetify (VResponsive.sass), ze vnitrni ".v-responsive__content"
   wrapper uvnitr v-img se flexboxem (align-items:stretch, defaultni chovani
   ".v-responsive" jako display:flex) skutecne roztahuje na celou vysku
   sveho rodice - takze v-img height="100%" (viz vyse) spravne zdedi uz
   spravne zmensenou vysku od v-main, bez jakehokoliv vlastniho odhadu. */
</style>
